import { Component } from 'react';
import './Activity.css';
import withAuth from '../components/withAuth';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Scheduler from '../components/Scheduler';
import NewImputation from '../components/NewImputation';
import InProgressCard from '../components/InProgressCard';
import { getEndOfDay, getCurrentDate, getCurrentDayString } from '../time'
import {
    is_modification_authorized, getActiveDay, fillCurrentState, getAllDays,
} from '../redux/day/dayActions';
import {
    initializeDays, setActiveDay, validateDaySendData, validateDay, startDay,
} from '../redux/day/dayEditionActions';
import {
    gotActivityInProgress, loadImputationsByDay, getAllImputations
} from '../redux/imputations/imputationsActions';
import { cleanOldImputations, stopImputationInDb } from '../redux/imputations/imputationsEditionActions';
import { castImputationForServerFormat } from '../redux/imputations/imputationsCast';
import { setGpsStopped } from '../redux/gps/gpsActions';
import { throwErrorMessage } from '../lib/error_helper'
import { getDriving } from '../redux/activityTypes/activityTypesActions'
import { compose } from 'redux'
import { connect } from 'react-redux';
import { loadActiveUser } from "../redux/users/usersActions";
import RefreshNewDay from "../components/RefreshNewDay";
import ActionButtonsActivity from "../components/ActionButtonsActivity";
import OptionChoicesActivity from "../components/OptionChoicesActivity";
import { dispatchWarning } from "../redux/parameter/parameterActions";
import { arraysAreSame } from "../lib/array_helper";
import { authorizedAppsFetchData } from '../redux/authorizedApps/authorizedAppsActions';
import { getStartedWorkOrder } from '../redux/intervention/interventionActions';
import InterventionAlreadyInProgressModal from '../components/Interventions/InterventionAlreadyInProgressModal'

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
});

class Activity extends Component {

    constructor(props) {
        super(props);
        let in_progress = undefined;

        if (props.imputations !== undefined) {
            for (let i = 0; i < props.imputations.length; i++) {
                if (props.imputations[i].in_progress) {
                    in_progress = props.imputations[i];
                }
            }
        }

        this.state = {
            activeUser: props.activeUser,
            date: getCurrentDate(true),
            current_day: null,
            today: null,
            create_imputation: false,
            create_driving: false,
            create_intervention: false,
            create_base_activity: null,
            current_imputation: in_progress === undefined ? null : in_progress,
            dayModificationAuthorized: true,
            on_day_change: false,
            list_mode: true,
            launch_validation_of_day: false,
            imputations: props.imputations,
            allDays: [],
            pauseInterventionModalOpenned: false,
            interventionToPause: null,
            forcingEndIntervention: false,
            currentAction: null,
            startDay: this.startDay.bind(this),
            checkDay: this.checkDay.bind(this),
        };

        this.props.setGpsStopped(false);
    }

    //création du jour courant s'il nexiste pas
    componentDidMount() {
        this.loadAllDays();
        this.props.fetchData(this.props.activeUser);

        this.props.initializeDays(this.state.activeUser.id).then((today) => {
            this.setState({ today: today.day });
            this.props.getActiveDay(this.state.activeUser.id);
        });

        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
        this.props.cleanOldImputations();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (nextProps.current_day !== undefined && nextProps.current_day !== false) {
            if (JSON.stringify(nextProps.current_day) !== JSON.stringify(prevState.current_day))
                prevState.startDay(nextProps.current_day);
            else {
                prevState.checkDay(nextProps.current_day)
                modifiedState.current_day = nextProps.current_day
            }
        }

        if (nextProps.imputations !== undefined && !arraysAreSame(nextProps.imputations, prevState.imputations)) {
            let in_progress = undefined;

            for (let i = 0; i < nextProps.imputations.length; i++) {
                if (nextProps.imputations[i].in_progress)
                    in_progress = nextProps.imputations[i];
            }

            modifiedState.imputations = nextProps.imputations;
            modifiedState.current_imputation = in_progress === undefined ? null : in_progress
        }

        return modifiedState
    }

    async checkDay(day) {
        if (this.mounted) {
            let modification = await is_modification_authorized(day);

            if (this.mounted) {
                if (modification !== this.state.modifiable)
                    this.setState({
                        modifiable: modification,
                    });
            }
        }
    }

    //démarrage du jour
    async startDay(day) {
        if (this.mounted)
            this.props.startDay(day).then((returnedModificationAndImputation) => {
                if (this.mounted) {
                    this.setState({
                        current_day: day,
                        modifiable: returnedModificationAndImputation.modification,
                        current_imputation: returnedModificationAndImputation.imputation,
                    });
                }

            });
    }

    changeDay(day) {
        this.loadAllDays();

        if (this.state.today.date !== getCurrentDayString())
            this.setState({ on_day_change: true });
        else
            this.props.setActiveDay(day, this.props.activeUser.id);
    }

    //action du bouton roulage
    startDriving() {
        if (this.state.current_day && this.state.current_day.date !== getCurrentDayString()
            && this.state.current_imputation && this.state.current_imputation.in_progress) {
            this.setState({ on_day_change: true });
        } else {

            getStartedWorkOrder().then((intervention) => {
                if (intervention && !this.state.forcingEndIntervention) {
                    this.setState({
                        interventionToPause: intervention,
                        pauseInterventionModalOpenned: true,
                        currentAction: this.startDriving.bind(this)
                    })

                    return;
                }

                this.setState({
                    forcingEndIntervention: false,
                    currentAction: null,
                })

                if (this.state.current_day.validation) {
                    this.props.throwErrorMessage({
                        title: "Erreur",
                        message: "Ce jour est déjà validé. Impossible de continuer la saisie",
                    });

                    return;
                }

                if (this.state.current_imputation === null || (this.state.current_imputation !== null && !this.state.current_imputation.activity.driving)) {
                    getDriving((activity) => {
                        this.setState({
                            create_driving: true,
                            create_base_activity: activity
                        });
                    });
                }
            })
        }
    }

    loadAllImputations() {
        this.props.getAllImputations(this.state.current_day);
    }

    loadAllDays() {
        getAllDays().then((days) => {
            this.setState({ allDays: days });
        })
    }

    closePauseInterventionModal() {
        this.setState({
            pauseInterventionModalOpenned: false,
            forcingEndIntervention: false,
            currentAction: null,
        })
    }

    //action du bouton imputation
    launchImputation() {
        if (this.state.current_day && this.state.current_day.date !== getCurrentDayString()
            && this.state.current_imputation && this.state.current_imputation.in_progress) {
            this.setState({ on_day_change: true });
        } else {

            getStartedWorkOrder().then((intervention) => {
                if (intervention && !this.state.forcingEndIntervention) {
                    this.setState({
                        interventionToPause: intervention,
                        pauseInterventionModalOpenned: true,
                        currentAction: this.launchImputation.bind(this)
                    })

                    return;
                }

                this.setState({
                    forcingEndIntervention: false,
                    currentAction: null,
                })

                if (this.state.current_day.validation) {
                    this.props.throwErrorMessage({
                        title: "Erreur",
                        message: "Ce jour est déjà validé. Impossible de continuer la saisie",
                    });

                    return;
                }

                this.setState({
                    create_imputation: true
                });
            })
        }
    }

    //fonction de retour de la fonction de création d'imputation
    createImputation(imputation) {
        let currentImputation = this.props.fillCurrentState([imputation])
        if (currentImputation && currentImputation !== null) {
            this.setState({
                currentImputation: currentImputation
            });
        }

        this.cancelImputation();
    }

    async stopImputation(imputation) {

        let endDate = getCurrentDate(true);
        if (this.state.current_day && this.state.current_day.date !== getCurrentDayString()) {
            this.setState({ on_day_change: true });
            endDate = new Date(new Date(imputation.date_start).setHours(23, 59, 0));
        }

        getStartedWorkOrder().then(async (intervention) => {
            if (intervention && !this.state.forcingEndIntervention) {
                this.setState({
                    interventionToPause: intervention,
                    pauseInterventionModalOpenned: true,
                    currentAction: this.stopImputation.bind(this, imputation)
                })

                return;
            }

            this.setState({
                forcingEndIntervention: false,
                pauseInterventionModalOpenned: false,
                currentAction: null,
            })

            if (imputation.date_start >= endDate) {
                this.props.throwErrorMessage({
                    title: "Erreur",
                    message: "L'horaire de début ne peut être supérieur ou égal à l'horaire de fin. La durée minimale d'une activité est d'une minute",
                });

                return;
            }

            let ok = await gotActivityInProgress(imputation);
            if (ok) {
                this.props.stopImputationInDb(imputation.id, endDate);
                this.setState({
                    current_imputation: null
                });
            } else {
                this.setState({
                    openError: true,
                    messageError: "Suppression " + imputation.activity.name + " en cours pour cause de chevauchement"
                });
            }
        });
    }

    closeError() {
        this.setState({
            openError: false
        });
    }

    //fermeture de la fenêtre de création d'impuation
    cancelImputation() {
        this.setState({
            create_imputation: false,
            create_driving: false,
            create_intervention: false,
            create_base_activity: null,
            currentAction: null,
            forcingEndIntervention: false,
            pauseInterventionModalOpenned: false,
        });

        this.props.setGpsStopped(false);
    }

    //changement d'état du switch gps
    changeGPS() {
        this.props.setGpsStopped(!this.props.gpsStopped);
    }

    //rappatriement de l'imputation créée à la suite d'un chevauchement e jour d'un imputation
    updateCurrentImputation(imputation) {
        this.setState({
            current_imputation: imputation
        });
    }

    closeChangeDay() {
        this.setState({ on_day_change: false });
    }

    stayOnDayAndCreateNewOne() {
        this.props.initializeDays(this.state.activeUser.id).then((today) => {
            this.setState({ today: today.day, on_day_change: false });
            this.forceUpdate();
        });
    }

    createNewDayAndSwitch() {
        this.props.initializeDays(this.state.activeUser.id).then((today) => {
            this.setState({ today: today.day, on_day_change: false });
            this.props.setActiveDay(today.day);
            this.forceUpdate();
        })
    }

    validationOfDay() {
        if (this.props.current_day.validation) {
            this.props.dispatchWarning("Validation impossible", "la journée est déjà validée", 5);
        } else {
            if (this.props.imputations.length === 0) {
                this.props.dispatchWarning("Validation impossible", "aucune imputation créée pour ce jour", 5);
            } else {
                let imputations = this.props.imputations.sort((a, b) => {
                    return (a.date_end === null ? (b.date_end === null ? (a.date_start < b.date_start ? 1 : -1) : -1) : (b.date_end === null ? 2 : (a.date_end < b.date_end ? 1 : (a.date_start < b.date_start ? 1 : -1))));
                });
                if (imputations[0].activity.home || imputations[0].date_end >= getEndOfDay(this.props.current_day.date)) {
                    this.props.validateDay(this.props.current_day, this.props.activeUser);
                    // this.props.validateDaySend(this.props.current_day, this.props.imputations.map(imputation => castImputationForServerFormat(imputation, this.props.user)));
                }
                else {
                    this.props.dispatchWarning("Validation impossible", "La dernière imputation ne se finit pas à 23h59 ou n'est pas une fin de journée", 10);
                }
            }
        }
    }

    forceEndIntervention() {
        this.setState({
            forcingEndIntervention: true,
        })

        this.state.currentAction();
    }

    changeDisplayMode() {
        this.setState({
            list_mode: !this.state.list_mode
        });
    }

    resendValidateDay() {
        this.props.validateDaySend(this.props.current_day, this.props.imputations.map(imputation => castImputationForServerFormat(imputation, this.props.user)));
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="container-fluid without-side-padding" style={{ minHeight: "90%", height: "90%", maxHeight: "90%", position: "relative" }}>
                    <OptionChoicesActivity current_day={this.props.current_day} changeGPS={this.changeGPS.bind(this)}
                        resendValidateDay={this.resendValidateDay.bind(this)}
                        changeDisplayMode={this.changeDisplayMode.bind(this)} validateDay={this.validationOfDay.bind(this)}
                        list_mode={this.state.list_mode} />
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        {(this.state.current_imputation !== null && this.state.current_imputation.in_progress) ?
                            <InProgressCard imputation={this.state.current_imputation}
                                stop={this.stopImputation.bind(this, this.state.current_imputation)} />
                            : null}
                        <div style={{ height: "2%" }} />
                        {this.props.current_day !== null && this.props.current_day !== false ?
                            <Scheduler current_day={this.props.current_day} changeDay={this.changeDay.bind(this)}
                                user={this.state.activeUser} modifiable={this.state.modifiable} displayModeListe={this.state.list_mode}
                                validationDay={this.props.current_day !== null ? this.props.current_day.validation : false}
                                maxSize={!(this.state.current_imputation !== null && this.state.current_imputation.in_progress)} />
                            : null}
                        <div style={{ height: "1%" }} />
                        <ActionButtonsActivity
                            driving={this.startDriving.bind(this)}
                            imputation={this.launchImputation.bind(this)}
                            modifiable={this.state.modifiable} />
                        {this.state.create_imputation || this.state.create_driving || this.state.create_intervention ?
                            <NewImputation end={this.createImputation.bind(this)} close={this.cancelImputation.bind(this)}
                                day={this.props.current_day} today={this.state.today} gps={!this.props.gpsStopped}
                                openDriving={this.state.create_driving} openIntervention={this.state.create_intervention}
                                activity={this.state.create_base_activity} user={this.state.activeUser} allDays={this.state.allDays} />
                            : null}
                        <RefreshNewDay open={this.state.on_day_change} exit={this.closeChangeDay.bind(this)}
                            stay={this.stayOnDayAndCreateNewOne.bind(this)}
                            new={this.createNewDayAndSwitch.bind(this)} />
                        <InterventionAlreadyInProgressModal interventionInProgress={this.state.interventionToPause} imputationMode
                            opened={this.state.pauseInterventionModalOpenned} forceEndIntervention={this.forceEndIntervention.bind(this)}
                            closeModal={this.closePauseInterventionModal.bind(this)} />
                    </div>
                </div>
            </div>
        );
    }
}

Activity.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        current_day: state.current_day,
        imputations: state.activeDayImputations,
        dayModificationAuthorized: state.dayModificationAuthorized,
        allImputations: state.imputations.allImputations,
        gpsStopped: state.gpsInformations.gpsStopped,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadActiveUser: () => dispatch(loadActiveUser()),
        stopImputationInDb: (id, time) => dispatch(stopImputationInDb(id, time)),
        setActiveDay: (day, userId) => dispatch(setActiveDay(day, userId)),
        getActiveDay: (user_id) => dispatch(getActiveDay(user_id)),
        loadImputationsByDay: (dayId) => dispatch(loadImputationsByDay(dayId)),
        validateDay: (day, user) => dispatch(validateDay(day, user)),
        validateDaySend: (day, imputations) => dispatch(validateDaySendData(day, imputations)),
        dispatchWarning: (title, message, time) => dispatch(dispatchWarning(title, message, time)),
        startDay: (day) => dispatch(startDay(day)),
        initializeDays: (userId) => dispatch(initializeDays(userId)),
        throwErrorMessage: (options) => dispatch(throwErrorMessage(options)),
        fillCurrentState: (imputations) => dispatch(fillCurrentState(imputations)),
        setGpsStopped: (value) => dispatch(setGpsStopped(value)),
        getAllImputations: (day) => dispatch(getAllImputations(day)),
        fetchData: (user) => dispatch(authorizedAppsFetchData(user)),
        cleanOldImputations: () => dispatch(cleanOldImputations())
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(Activity)
